import { EntityPageFocusType } from '@xing-com/crate-common-graphql-types';

import type { EntityPageModulesQuery } from '../../graphql/queries/entity-page-modules-query.gql-types';

const activeModules: {
  [name: string]: NonNullable<
    Extract<
      NonNullable<EntityPageModulesQuery['entityPageEX']>,
      { __typename?: 'EntityPage' }
    >['modules']
  >['collection'][number];
} = {
  // header: {
  //   __typename: 'EntityPageHeaderModule',
  //   type: 'header',
  //   properties: {
  //     cta: 'follow',
  //   },
  //   globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:header',
  //   content: {
  //     __typename: 'EntityPageCompanyHeaderContent',
  //     followers: {
  //       total: 7,
  //       __typename: 'FollowersConnection',
  //     },
  //     company: {
  //       id: '423.744d79',
  //       employeesCount: 6,
  //       companySizeRange: {
  //         min: 1,
  //         max: 1,
  //         __typename: 'CompanySizeRange',
  //       },
  //       industry: {
  //         id: '230400.78ae4e',
  //         __typename: 'Industry',
  //       },
  //       __typename: 'Company',
  //     },
  //   },
  // },
  about_us: {
    __typename: 'EntityPageAboutUsModule',
    type: 'about_us',
  },
  jobs: {
    __typename: 'EntityPageGenericModule',
    type: 'jobs',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:jobs',
    properties: null,
  },
  employees: {
    __typename: 'EntityPageGenericModule',
    type: 'employees',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:employees',
    properties: null,
  },
  contacts: {
    __typename: 'EntityPageGenericModule',
    type: 'contacts',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:contacts',
    properties: null,
  },
  locations: {
    __typename: 'EntityPageGenericModule',
    type: 'locations',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:locations',
    properties: null,
  },
  ideal_employer: {
    __typename: 'EntityPageGenericModule',
    type: 'ideal_employer',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:ideal_employer',
    properties: null,
  },
  news: {
    __typename: 'EntityPageGenericModule',
    type: 'news',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:updates',
    properties: {
      hasSubpage: true,
    },
  },
  articles: {
    __typename: 'EntityPageGenericModule',
    type: 'articles',
    globalId: 'surn:x-xing:entitypages:page:423.744d79:modules:updates',
    properties: null,
  },
};

export const generateEntityPageModules = ({
  modules = [
    'about_us',
    'jobs',
    'employees',
    'contacts',
    'locations',
    'ideal_employer',
    'news',
  ],
} = {}): EntityPageModulesQuery => ({
  __typename: 'Query',
  entityPageEX: {
    __typename: 'EntityPage',
    id: '423.744d79',
    modules: {
      collection: modules.map((module) => activeModules[module]),
      __typename: 'EntityPageModules',
    },
  },
});

export const mockedModulesByFocusType: Record<string, string[]> = {
  [EntityPageFocusType.Company]: [
    'about_us',
    'jobs',
    'employees',
    'contacts',
    'locations',
    'ideal_employer',
    'news',
  ],
  [EntityPageFocusType.Publisher]: ['articles', 'about_us'],
};
